import { render, staticRenderFns } from "./Referrer.vue?vue&type=template&id=3e49994a&scoped=true"
import script from "./Referrer.vue?vue&type=script&lang=js"
export * from "./Referrer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49994a",
  null
  
)

export default component.exports